/* Holasticker · personalizador único
   ---------------------------------------------------------------------------
   Un solo editor para todos los productos. Lo que cambia de un producto a
   otro no está aquí: está en la ficha técnica que cada producto guarda en
   Shopify (metacampo holastiker.ficha) y que la plantilla publica en
   window.HSFicha. Dar de alta un producto nuevo no toca este archivo.

   La ficha dice:
     - el lienzo y la silueta del producto (camiseta, taza, llavero…)
     - de qué color se pinta (fijo, o según la opción Color del producto)
     - cuántas caras tiene, cuáles son obligatorias y dónde se imprime
     - si alguna cara se puede dejar sin diseño

   Reglas de la casa, las de siempre:
   - Todo va en try/catch: si algo falla aquí, comprar sigue funcionando.
   - Lo que ve el cliente y lo que se exporta salen de la misma función.
*/
(function () {
  'use strict';

  if (window.HSPersonalizador) return;

  var F = window.HSFicha;
  if (!F || !F.caras || !F.caras.length) return;   // producto sin personalizar

  var EXPORT_MAX = 1000;
  var ZOOM_MIN = 0.2, ZOOM_MAX = 6;
  var ROSA = (F.guia && F.guia.color) || '#ff4d94';
  /* El lienzo puede ser fijo o depender de la opción elegida: una lona de
     50x200 no tiene la misma proporción que una de 50x50. */
  function LZ() {
    var d = F.lienzo_opcion;
    if (d && d.mapa) {
      var v = d.mapa[etiqueta(d.grupo || 'tamano', '')];
      if (v) return v;
    }
    return F.lienzo || [1000, 1000];
  }

  /* Productos que se cortan en varias formas: la silueta, los detalles y la
     zona de impresión salen de la forma que haya elegido el cliente. */
  function formaActual() {
    var d = F.formas;
    if (!d || !d.mapa) return null;
    return d.mapa[etiqueta(d.grupo || 'forma', '')] || null;
  }

  /* --- Campos que viajan con el pedido -------------------------------------
     Una cara: "Diseño" y su vista previa. Varias: un campo por cara. */

  var CARAS = F.caras;
  var UNA = CARAS.length === 1;

  function campos(c) {
    var suf = UNA ? '' : ' ' + (c.campo || c.nombre.toLowerCase());
    return {
      archivo: 'properties[Diseño' + suf + ']',
      previa: UNA ? 'properties[_vista_previa]' : 'properties[_vista_previa ' + (c.campo || c.nombre.toLowerCase()) + ']',
      omitida: 'properties[' + (c.nombre || 'Cara') + ']'
    };
  }

  var PROP_ENCUADRE = 'properties[_encuadre]';

  /* --- Utilidades --------------------------------------------------------- */

  function el(tag, clase, texto) {
    var n = document.createElement(tag);
    if (clase) n.className = clase;
    if (texto != null) n.textContent = texto;
    return n;
  }

  function boton(txt, clase) {
    var b = el('button', clase, txt);
    b.type = 'button';
    return b;
  }

  function limitar(v, min, max) { return v < min ? min : (v > max ? max : v); }

  function radio(grupo) {
    return document.querySelector('[data-hs-group="' + grupo + '"]:checked');
  }

  function etiqueta(grupo, porDefecto) {
    var r = radio(grupo);
    return r ? r.dataset.hsLabel : (porDefecto || '');
  }

  /* Color del producto: fijo en la ficha, o el de la opción elegida. */
  function colorActual() {
    var f = F.fondo || {};
    if (f.relleno && f.relleno.indexOf('opcion:') === 0) {
      var r = radio('color');
      if (r && r.dataset.hsHex) return r.dataset.hsHex;
    }
    if (f.relleno && f.relleno.charAt(0) === '#') return f.relleno;
    return '#ffffff';
  }

  /* Color de los detalles de adorno (asa de la taza, tirantes del delantal):
     puede ser el de la opción elegida aunque el cuerpo sea fijo. */
  function colorAcento() {
    var f = F.fondo || {};
    if (f.acento && f.acento.indexOf('opcion:') === 0) {
      var r = radio('color');
      if (r && r.dataset.hsHex) return r.dataset.hsHex;
    }
    if (f.acento && f.acento.charAt(0) === '#') return f.acento;
    return colorActual();
  }

  function formularioCompra() {
    return document.querySelector('form[action*="/cart/add"]');
  }

  function ponerArchivo(nombre, file) {
    var f = formularioCompra();
    if (!f) return false;
    var input = f.querySelector('input[type="file"][name="' + nombre + '"][data-hs-generado]');
    if (!file) { if (input) input.remove(); return true; }
    if (!input) {
      input = document.createElement('input');
      input.type = 'file';
      input.name = nombre;
      input.hidden = true;
      input.setAttribute('data-hs-generado', '');
      f.appendChild(input);
    }
    try {
      var dt = new DataTransfer();
      dt.items.add(file);
      input.files = dt.files;
    } catch (e) { return false; }
    f.setAttribute('enctype', 'multipart/form-data');
    return true;
  }

  function ponerTexto(nombre, valor) {
    var f = formularioCompra();
    if (!f) return;
    var input = f.querySelector('input[type="hidden"][name="' + nombre + '"]');
    if (valor == null || valor === '') { if (input) input.remove(); return; }
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = nombre;
      f.appendChild(input);
    }
    input.value = valor;
  }

  function hexRgb(h) {
    h = (h || '#ffffff').replace('#', '');
    return [parseInt(h.substr(0, 2), 16), parseInt(h.substr(2, 2), 16), parseInt(h.substr(4, 2), 16)];
  }
  function esClaro(h) { var c = hexRgb(h); return (c[0] * 299 + c[1] * 587 + c[2] * 114) / 1000 > 150; }
  function tono(h, f) {
    return 'rgb(' + hexRgb(h).map(function (v) {
      return Math.max(0, Math.min(255, Math.round(v * f)));
    }).join(',') + ')';
  }

  /* --- Texturas (madera, cartón…) ------------------------------------------ */

  var textura = null;
  (function () {
    var f = F.fondo || {};
    if (!f.textura) return;
    var i = new Image();
    i.onload = function () { textura = i; repintar(); };
    i.src = f.textura;
  })();

  /* --- Fotos de producto ----------------------------------------------------
     Si la ficha trae foto del producto (por cara y, si hay, por color), el
     personalizador la usa de fondo en vez del dibujo. Si falta la del color
     elegido, se dibuja la silueta, que siempre sale del color correcto. */

  var fotos = {};

  function fotoDe(id) {
    var f = F.fondo || {};
    var por = (f.fotos && (f.fotos[id] || f.fotos['*'])) || null;
    var url = null;
    if (por) {
      url = typeof por === 'string' ? por : (por[etiqueta('color', '')] || por['*'] || null);
    }
    if (!url) return null;
    if (fotos[url] === undefined) {
      fotos[url] = null;
      var i = new Image();
      i.crossOrigin = 'anonymous';         // hace falta para poder exportar
      i.onload = function () { fotos[url] = i; repintar(); };
      i.onerror = function () { fotos[url] = false; };
      i.src = url;
    }
    return fotos[url] || null;
  }

  function relleno(ctx) {
    if (textura) {
      try { return ctx.createPattern(textura, 'repeat'); } catch (e) {}
    }
    return colorActual();
  }

  /* --- Estado -------------------------------------------------------------- */

  function caraVacia() {
    return { img: null, nombre: '', t: { escala: 1, x: 0, y: 0, giro: 0 }, guardado: false, estado: 'ninguno' };
  }

  var datos = {};
  CARAS.forEach(function (c) { datos[c.id] = caraVacia(); });

  /* Posición de impresión elegida en cada cara. Si la ficha no trae
     posiciones, se usa la zona única de la cara. */
  var posicion = {};
  CARAS.forEach(function (c) {
    if (c.posiciones && c.posiciones.length) posicion[c.id] = c.posiciones[0].id;
  });

  function posDe(id) {
    var c = cara(id);
    if (!c.posiciones || !c.posiciones.length) return null;
    for (var i = 0; i < c.posiciones.length; i++) {
      if (c.posiciones[i].id === posicion[id]) return c.posiciones[i];
    }
    return c.posiciones[0];
  }

  function zonaDe(id) {
    var p = posDe(id);
    var c = cara(id);
    var fm = formaActual();
    if (fm && fm.zona && !(p && p.zona)) return fm.zona;
    var rel = (p && p.zona_rel) || c.zona_rel;
    if (rel) {
      var L = LZ();
      return { x: rel.x * L[0], y: rel.y * L[1], w: rel.w * L[0], h: rel.h * L[1],
               forma: rel.forma || 'rect' };
    }
    return (p && p.zona) || c.zona;
  }

  var activa = CARAS[0].id;
  var combinacionOk = true;
  /* Si el cliente no tiene el diseno a mano, compra igual y lo manda despues. */
  var despues = false;
  var PROP_DESPUES = 'properties[Envío del diseño]';
  var TXT_DESPUES = 'Lo envío después (email o WhatsApp)';
  var inputs = {};

  var modal = null, lienzo = null, ctx = null, zoomInput = null, subtitulo = null;
  var pestanas = null, vacio = null, vacioTxt = null, bGuardar = null, avisoZona = null, bOmitir = null;
  var posFila = null;

  function cara(id) {
    for (var i = 0; i < CARAS.length; i++) if (CARAS[i].id === id) return CARAS[i];
    return CARAS[0];
  }

  function inputDe(id) {
    if (!inputs[id]) inputs[id] = document.querySelector('input[type="file"][data-hs-input="' + id + '"]');
    return inputs[id];
  }

  /* --- Dibujo --------------------------------------------------------------
     Todo se dibuja en la caja de la ficha (por ejemplo 1000 x 1000) y luego
     se escala al tamaño del lienzo. Así la vista y la exportación coinciden. */

  function trazoZona(c, z) {
    c.beginPath();
    if (z.forma === 'circulo') {
      c.arc(z.x + z.w / 2, z.y + z.h / 2, Math.min(z.w, z.h) / 2, 0, Math.PI * 2);
    } else if (z.forma === 'silueta' && z.path) {
      return new Path2D(z.path);
    } else {
      var r = z.radio || 0;
      if (!r) { c.rect(z.x, z.y, z.w, z.h); }
      else {
        c.moveTo(z.x + r, z.y);
        c.arcTo(z.x + z.w, z.y, z.x + z.w, z.y + z.h, r);
        c.arcTo(z.x + z.w, z.y + z.h, z.x, z.y + z.h, r);
        c.arcTo(z.x, z.y + z.h, z.x, z.y, r);
        c.arcTo(z.x, z.y, z.x + z.w, z.y, r);
      }
    }
    c.closePath();
    return null;
  }

  function dibujar(c, w, h, id, conGuia) {
    var cfg = cara(id);
    var z = zonaDe(id);
    var d = datos[id];
    var fondo = F.fondo || {};
    var col = colorActual();
    var L = LZ();
    var kx = w / L[0], ky = h / L[1];

    c.clearRect(0, 0, w, h);
    c.save();
    c.scale(kx, ky);

    var forma = formaActual();
    var silueta = (forma && forma.silueta)
      || (fondo.silueta && (fondo.silueta[id] || fondo.silueta['*']));
    var cuerpo = silueta ? new Path2D(silueta) : null;

    /* Lona: el panel y los ojales se calculan, porque cada tamaño tiene
       una proporción distinta y no sirve una silueta fija. */
    if (fondo.modo === 'lona') {
      dibujarLona(c, L, fondo, z, d, cfg, conGuia);
      c.restore();
      return;
    }

    /* 1. El producto: foto real si la hay, si no el dibujo */
    var foto = fotoDe(id);
    if (foto) {
      c.drawImage(foto, 0, 0, L[0], L[1]);
    } else if (fondo.modo !== 'ninguno') {
      c.save();
      if (fondo.sombra !== false) {
        c.shadowColor = 'rgba(0,0,0,0.18)';
        c.shadowBlur = 24;
        c.shadowOffsetY = 10;
      }
      c.fillStyle = relleno(c);
      if (cuerpo) c.fill(cuerpo);
      else c.fillRect(0, 0, L[0], L[1]);
      c.restore();
    }

    /* 2. El diseño, recortado a la zona de impresión */
    if (d.img) {
      c.save();
      var recorte = fondo.recorta && cuerpo ? cuerpo : null;
      if (recorte) c.clip(recorte);
      else {
        var p = trazoZona(c, z);
        if (p) c.clip(p); else c.clip();
      }
      var base = (cfg.ajuste === 'cover')
        ? Math.max(z.w / d.img.naturalWidth, z.h / d.img.naturalHeight)
        : Math.min(z.w / d.img.naturalWidth, z.h / d.img.naturalHeight);
      var e = base * d.t.escala;
      c.translate(z.x + z.w / 2 + d.t.x * z.w, z.y + z.h / 2 + d.t.y * z.h);
      c.rotate(d.t.giro * Math.PI / 180);
      c.imageSmoothingQuality = 'high';
      c.drawImage(d.img,
        -d.img.naturalWidth * e / 2, -d.img.naturalHeight * e / 2,
        d.img.naturalWidth * e, d.img.naturalHeight * e);
      c.restore();
    }

    /* 3. Detalles del producto: costuras, ribetes, asas…
       Con foto real no se dibuja nada de esto: ya está en la foto. */
    var linea = esClaro(col) ? tono(col, 0.78) : tono(col, 1.7);
    if (cuerpo && !foto) {
      c.save();
      c.strokeStyle = linea;
      c.lineWidth = 3;
      c.stroke(cuerpo);
      c.restore();
    }
    /* Detalles: costuras, asas, tapones… Cada uno puede ser solo un trazo
       ("M…"), o un objeto { d, w, c, fill } con grosor, color y relleno.
       c: "linea" (tono del producto), "acento" (el color elegido) o un #hex. */
    var det = !foto && ((forma && forma.detalles)
      || (fondo.detalles && (fondo.detalles[id] || fondo.detalles['*'])));
    if (det) {
      var acento = colorAcento();
      det.forEach(function (p) {
        var o = (typeof p === 'string') ? { d: p } : p;
        /* Detalles que solo salen con cierta opción: el lazo de la medalla. */
        if (o.si && etiqueta(o.si.grupo, '') !== o.si.valor) return;
        var tinta = o.c === 'acento' ? acento
          : o.c === 'cuerda' ? (window.HSCuerda || (F.cuerda && F.cuerda.defecto) || '#e8dcc3')
          : (o.c && o.c.charAt(0) === '#' ? o.c : linea);
        c.save();
        var path = new Path2D(o.d);
        if (o.fill) {
          c.fillStyle = tinta;
          c.fill(path);
          c.strokeStyle = esClaro(tinta) ? tono(tinta, 0.8) : tono(tinta, 1.5);
          c.lineWidth = o.w || 3;
          c.stroke(path);
        } else {
          c.strokeStyle = tinta;
          c.lineWidth = o.w || 3;
          c.lineCap = 'round';
          c.stroke(path);
        }
        c.restore();
      });
    }

    /* 4. La guía de impresión, que no se imprime */
    if (conGuia && !fondo.recorta) {
      c.save();
      c.setLineDash([16, 11]);
      c.lineWidth = 5;
      c.strokeStyle = 'rgba(255,255,255,0.85)';
      var p2 = trazoZona(c, z);
      if (p2) c.stroke(p2); else c.stroke();
      c.lineWidth = 3.5;
      c.strokeStyle = ROSA;
      var p3 = trazoZona(c, z);
      if (p3) c.stroke(p3); else c.stroke();
      c.restore();
    } else if (conGuia && cuerpo && !foto) {
      c.save();
      c.setLineDash([16, 11]);
      c.lineWidth = 4;
      c.strokeStyle = ROSA;
      c.stroke(cuerpo);
      c.restore();
    }

    c.restore();
  }

  /* --- Lona ----------------------------------------------------------------
     Panel blanco con dobladillo y ojales repartidos por el contorno: uno en
     cada esquina y los demás cada 50 cm aproximadamente. */

  function dibujarLona(c, L, fondo, z, d, cfg, conGuia) {
    var W = L[0], H = L[1];
    var corto = Math.min(W, H);
    var m = corto * 0.055;                   // dobladillo
    var r = corto * 0.034;                   // radio del ojal, visible en pantalla

    c.save();
    c.shadowColor = 'rgba(0,0,0,0.18)';
    c.shadowBlur = Math.min(W, H) * 0.05;
    c.shadowOffsetY = Math.min(W, H) * 0.02;
    c.fillStyle = fondo.color || '#ffffff';
    c.fillRect(0, 0, W, H);
    c.restore();

    if (d.img) {
      c.save();
      c.beginPath();
      c.rect(z.x, z.y, z.w, z.h);
      c.clip();
      var base = (cfg.ajuste === 'cover')
        ? Math.max(z.w / d.img.naturalWidth, z.h / d.img.naturalHeight)
        : Math.min(z.w / d.img.naturalWidth, z.h / d.img.naturalHeight);
      var e = base * d.t.escala;
      c.translate(z.x + z.w / 2 + d.t.x * z.w, z.y + z.h / 2 + d.t.y * z.h);
      c.rotate(d.t.giro * Math.PI / 180);
      c.imageSmoothingQuality = 'high';
      c.drawImage(d.img, -d.img.naturalWidth * e / 2, -d.img.naturalHeight * e / 2,
        d.img.naturalWidth * e, d.img.naturalHeight * e);
      c.restore();
    }

    /* dobladillo y borde */
    c.save();
    c.strokeStyle = 'rgba(31,41,51,0.25)';
    c.lineWidth = Math.max(1, Math.min(W, H) * 0.004);
    c.strokeRect(0, 0, W, H);
    c.setLineDash([Math.min(W, H) * 0.02, Math.min(W, H) * 0.015]);
    c.strokeStyle = 'rgba(31,41,51,0.18)';
    c.strokeRect(m * 0.55, m * 0.55, W - m * 1.1, H - m * 1.1);
    c.restore();

    /* Ojales: solo si el cliente los ha pedido. El número sale de la opción
       elegida ("6 ojales", "8 ojales"); sin ella, la lona va lisa. */
    var cuantos = 0;
    if (fondo.ojales_grupo) {
      var txt = etiqueta(fondo.ojales_grupo, '');
      var n = /(\d+)/.exec(txt);
      cuantos = n ? parseInt(n[1], 10) : 0;
    }
    var puntos = [];
    if (cuantos >= 4) {
      /* las cuatro esquinas, y el resto repartido por los lados largos */
      puntos.push([m, m], [W - m, m], [W - m, H - m], [m, H - m]);
      var sueltos = cuantos - 4;
      if (sueltos > 0) {
        var porLado = Math.ceil(sueltos / 2);
        var largoX = W >= H;
        for (var k = 1; k <= porLado; k++) {
          var t = k / (porLado + 1);
          if (largoX) {
            puntos.push([m + (W - 2 * m) * t, m]);
            if (puntos.length < cuantos) puntos.push([m + (W - 2 * m) * t, H - m]);
          } else {
            puntos.push([m, m + (H - 2 * m) * t]);
            if (puntos.length < cuantos) puntos.push([W - m, m + (H - 2 * m) * t]);
          }
        }
        puntos = puntos.slice(0, cuantos);
      }
    }
    c.save();
    puntos.forEach(function (p) {
      c.beginPath();
      c.arc(p[0], p[1], r, 0, Math.PI * 2);
      c.fillStyle = '#e9ecef';
      c.fill();
      c.lineWidth = r * 0.42;
      c.strokeStyle = '#aab2bb';
      c.stroke();
      c.beginPath();
      c.arc(p[0], p[1], r * 0.55, 0, Math.PI * 2);
      c.fillStyle = 'rgba(0,0,0,0.12)';
      c.fill();
    });
    c.restore();

    if (conGuia) {
      c.save();
      c.setLineDash([Math.min(W, H) * 0.03, Math.min(W, H) * 0.02]);
      c.lineWidth = Math.max(2, Math.min(W, H) * 0.006);
      c.strokeStyle = 'rgba(255,255,255,0.85)';
      c.strokeRect(z.x, z.y, z.w, z.h);
      c.lineWidth = Math.max(1.5, Math.min(W, H) * 0.0045);
      c.strokeStyle = ROSA;
      c.strokeRect(z.x, z.y, z.w, z.h);
      c.restore();
    }
  }

  function repintar() {
    if (!lienzo || !ctx) return;
    dibujar(ctx, lienzo.width, lienzo.height, activa, true);
  }

  function medirLienzo() {
    if (!lienzo) return;
    var caja = lienzo.parentElement;
    var dispW = Math.max(160, caja.clientWidth - 20);
    var dispH = Math.max(160, Math.round(window.innerHeight * 0.42));
    var L = LZ();
    var ratio = L[0] / L[1];
    var w = dispW, h = w / ratio;
    if (h > dispH) { h = dispH; w = h * ratio; }

    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    lienzo.style.width = Math.round(w) + 'px';
    lienzo.style.height = Math.round(h) + 'px';
    lienzo.width = Math.round(w * dpr);
    lienzo.height = Math.round(h * dpr);
    repintar();
  }

  /* --- Gestos -------------------------------------------------------------- */

  function conectarGestos() {
    var arrastrando = false, px = 0, py = 0;
    var punteros = {}, distIni = 0, escalaIni = 1;

    function t() { return datos[activa].t; }

    lienzo.addEventListener('pointerdown', function (e) {
      if (!datos[activa].img) return;
      lienzo.setPointerCapture(e.pointerId);
      punteros[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(punteros);
      if (ids.length === 1) { arrastrando = true; px = e.clientX; py = e.clientY; }
      else if (ids.length === 2) { arrastrando = false; distIni = separacion(punteros, ids); escalaIni = t().escala; }
    });

    lienzo.addEventListener('pointermove', function (e) {
      if (!punteros[e.pointerId]) return;
      punteros[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(punteros);
      if (ids.length >= 2 && distIni > 0) {
        t().escala = limitar(escalaIni * (separacion(punteros, ids) / distIni), ZOOM_MIN, ZOOM_MAX);
        if (zoomInput) zoomInput.value = String(t().escala);
        repintar();
        return;
      }
      if (!arrastrando) return;
      var r = lienzo.getBoundingClientRect();
      var z = zonaDe(activa);
      var L = LZ();
      t().x += (e.clientX - px) / Math.max(1, r.width * z.w / L[0]);
      t().y += (e.clientY - py) / Math.max(1, r.height * z.h / L[1]);
      px = e.clientX; py = e.clientY;
      repintar();
    });

    function soltar(e) {
      delete punteros[e.pointerId];
      if (Object.keys(punteros).length < 2) distIni = 0;
      if (Object.keys(punteros).length === 0) arrastrando = false;
    }
    lienzo.addEventListener('pointerup', soltar);
    lienzo.addEventListener('pointercancel', soltar);

    lienzo.addEventListener('wheel', function (e) {
      if (!datos[activa].img) return;
      e.preventDefault();
      t().escala = limitar(t().escala * (e.deltaY < 0 ? 1.08 : 0.925), ZOOM_MIN, ZOOM_MAX);
      if (zoomInput) zoomInput.value = String(t().escala);
      repintar();
    }, { passive: false });
  }

  function separacion(p, ids) {
    var a = p[ids[0]], b = p[ids[1]];
    return Math.hypot(a.x - b.x, a.y - b.y);
  }

  /* --- Modal --------------------------------------------------------------- */

  function construir() {
    modal = el('div', 'hs-ed hs-ed--llavero hs-ed--generico');
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Ajusta tu diseño');
    modal.hidden = true;

    var fondo = el('div', 'hs-ed__fondo');
    var panel = el('div', 'hs-ed__panel');

    var cab = el('div', 'hs-ed__cab');
    var tit = el('div', 'hs-ed__tit');
    tit.appendChild(el('h2', 'hs-ed__h', 'Ajusta tu diseño'));
    subtitulo = el('p', 'hs-ed__sub', '');
    tit.appendChild(subtitulo);
    var cerrar = el('button', 'hs-ed__x', '×');
    cerrar.type = 'button';
    cerrar.setAttribute('aria-label', 'Cerrar');
    cab.appendChild(tit);
    cab.appendChild(cerrar);

    pestanas = el('div', 'hs-ed__caras');
    pestanas.setAttribute('role', 'tablist');
    pestanas.style.gridTemplateColumns = 'repeat(' + CARAS.length + ', 1fr)';
    CARAS.forEach(function (c) {
      var b = boton(c.nombre_largo || c.nombre, 'hs-ed__cara');
      b.setAttribute('role', 'tab');
      b.setAttribute('data-hs-cara', c.id);
      b.appendChild(el('span', 'hs-ed__caraok', '✓'));
      b.addEventListener('click', function () { cambiarCara(c.id); });
      pestanas.appendChild(b);
    });
    pestanas.hidden = UNA;

    var escena = el('div', 'hs-ed__escena');
    lienzo = document.createElement('canvas');
    lienzo.className = 'hs-ed__lienzo';
    ctx = lienzo.getContext('2d');
    escena.appendChild(lienzo);

    vacio = el('div', 'hs-ed__vacio');
    vacio.hidden = true;
    vacioTxt = el('p', 'hs-ed__vaciotxt', '');
    vacio.appendChild(vacioTxt);
    var bSubir = boton('Subir diseño', 'hs-ed__b hs-ed__b--fuerte');
    bSubir.addEventListener('click', function () { var i = inputDe(activa); if (i) i.click(); });
    vacio.appendChild(bSubir);
    bOmitir = boton('', 'hs-ed__b hs-ed__b--plano');
    bOmitir.hidden = true;
    bOmitir.addEventListener('click', function () { omitir(activa, true); cerrarModal(); });
    vacio.appendChild(bOmitir);
    escena.appendChild(vacio);

    /* Posiciones de impresión: solo si la ficha de la cara las trae.
       Van debajo del lienzo, no dentro de la escena. */
    posFila = el('div', 'hs-ed__pos');
    posFila.hidden = true;

    avisoZona = el('p', 'hs-ed__aviso', '');

    var mandos = el('div', 'hs-ed__mandos');
    var filaZoom = el('label', 'hs-ed__zoom');
    filaZoom.appendChild(el('span', 'hs-ed__zoomtxt', 'Zoom'));
    zoomInput = document.createElement('input');
    zoomInput.type = 'range';
    zoomInput.min = String(ZOOM_MIN);
    zoomInput.max = String(ZOOM_MAX);
    zoomInput.step = '0.01';
    zoomInput.value = '1';
    zoomInput.className = 'hs-ed__rango';
    filaZoom.appendChild(zoomInput);
    mandos.appendChild(filaZoom);

    var acciones = el('div', 'hs-ed__acciones');
    var bGirar = boton('Girar 90°', 'hs-ed__b');
    var bCentrar = boton('Centrar', 'hs-ed__b');
    var bOtro = boton('Cambiar imagen', 'hs-ed__b');
    acciones.appendChild(bGirar);
    acciones.appendChild(bCentrar);
    acciones.appendChild(bOtro);
    mandos.appendChild(acciones);

    var pie = el('div', 'hs-ed__pie');
    var bCancelar = boton('Cancelar', 'hs-ed__b hs-ed__b--plano');
    bGuardar = boton('Guardar vista previa', 'hs-ed__b hs-ed__b--fuerte');
    pie.appendChild(bCancelar);
    pie.appendChild(bGuardar);

    panel.appendChild(cab);
    panel.appendChild(pestanas);
    panel.appendChild(escena);
    panel.appendChild(posFila);
    panel.appendChild(avisoZona);
    panel.appendChild(mandos);
    panel.appendChild(pie);
    modal.appendChild(fondo);
    modal.appendChild(panel);
    document.body.appendChild(modal);

    fondo.addEventListener('click', cerrarModal);
    cerrar.addEventListener('click', cerrarModal);
    bCancelar.addEventListener('click', cerrarModal);
    bGuardar.addEventListener('click', guardar);
    bGirar.addEventListener('click', function () {
      var t = datos[activa].t; t.giro = (t.giro + 90) % 360; repintar();
    });
    bCentrar.addEventListener('click', function () {
      datos[activa].t = { escala: 1, x: 0, y: 0, giro: 0 };
      if (zoomInput) zoomInput.value = '1';
      repintar();
    });
    bOtro.addEventListener('click', function () { var i = inputDe(activa); if (i) i.click(); });
    zoomInput.addEventListener('input', function () {
      datos[activa].t.escala = parseFloat(zoomInput.value) || 1;
      repintar();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal && !modal.hidden) cerrarModal();
    });
    window.addEventListener('resize', function () { if (modal && !modal.hidden) medirLienzo(); });

    conectarGestos();
  }

  function hecha(id) {
    var d = datos[id];
    return d.guardado || d.estado === 'sin-previa' || d.estado === 'omitida';
  }

  function resumenOpciones() {
    var p = [];
    (F.opciones || []).forEach(function (o) {
      var t = etiqueta(o.grupo || o.tipo, '');
      if (t) p.push(t);
    });
    return p.join(' · ');
  }

  function pintarModal() {
    if (!modal) return;
    var cfg = cara(activa);
    var res = resumenOpciones();
    subtitulo.textContent = (res ? res + (UNA ? '' : ' · ') : '') + (UNA ? '' : (cfg.nombre_largo || cfg.nombre));

    pestanas.querySelectorAll('[data-hs-cara]').forEach(function (b) {
      var id = b.getAttribute('data-hs-cara');
      var on = id === activa;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
      b.classList.toggle('is-hecha', hecha(id));
    });

    var hay = !!datos[activa].img;
    vacio.hidden = hay;
    vacioTxt.textContent = cfg.texto_vacio || 'Sube el diseño para esta cara.';
    bOmitir.hidden = !cfg.omitible;
    bOmitir.textContent = cfg.texto_omitir || 'No quiero nada aquí';
    ['.hs-ed__mandos', '.hs-ed__pie'].forEach(function (s) {
      var n = modal.querySelector(s);
      if (n) n.style.display = hay ? '' : 'none';
    });
    if (zoomInput) zoomInput.value = String(datos[activa].t.escala);

    pintarPosiciones(cfg);

    avisoZona.textContent = cfg.aviso || 'La línea rosa marca la zona de impresión. Lo que quede fuera no se imprime.';
    avisoZona.hidden = !avisoZona.textContent;

    var siguiente = pendiente(activa);
    bGuardar.textContent = siguiente ? 'Guardar y seguir' : 'Guardar vista previa';
  }

  function pintarPosiciones(cfg) {
    if (!posFila) return;
    var hay = !!(cfg.posiciones && cfg.posiciones.length > 1) && !!datos[cfg.id].img;
    posFila.hidden = !hay;
    if (!hay) { posFila.innerHTML = ''; return; }

    if (posFila.dataset.hsCara !== cfg.id) {
      posFila.dataset.hsCara = cfg.id;
      posFila.innerHTML = '';
      posFila.appendChild(el('span', 'hs-ed__postit', 'Dónde va'));
      cfg.posiciones.forEach(function (p) {
        var b = boton(p.nombre, 'hs-ed__posb');
        b.setAttribute('data-hs-pos', p.id);
        b.addEventListener('click', function () {
          posicion[cfg.id] = p.id;
          /* Al cambiar de sitio, el diseño vuelve al centro de la zona nueva. */
          datos[cfg.id].t = { escala: 1, x: 0, y: 0, giro: datos[cfg.id].t.giro };
          if (zoomInput) zoomInput.value = '1';
          pintarPosiciones(cfg);
          repintar();
          if (datos[cfg.id].guardado) guardarCara(cfg.id).catch(function () {});
        });
        posFila.appendChild(b);
      });
    }
    posFila.querySelectorAll('[data-hs-pos]').forEach(function (b) {
      b.classList.toggle('is-on', b.getAttribute('data-hs-pos') === posicion[cfg.id]);
    });
  }

  /* Primera cara obligatoria sin terminar, distinta de la actual. */
  function pendiente(actual) {
    for (var i = 0; i < CARAS.length; i++) {
      var c = CARAS[i];
      if (c.id !== actual && c.obligatoria !== false && !hecha(c.id)) return c.id;
    }
    return null;
  }

  function abrirModal() {
    if (!modal) construir();
    modal.hidden = false;
    document.body.classList.add('hs-ed-abierto');
    pintarModal();
    requestAnimationFrame(medirLienzo);
  }

  function cerrarModal() {
    if (!modal) return;
    modal.hidden = true;
    document.body.classList.remove('hs-ed-abierto');
  }

  function cambiarCara(id) {
    activa = id;
    pintarModal();
    medirLienzo();
  }

  /* --- Carga de imagen ----------------------------------------------------- */

  function cargar(file) {
    return new Promise(function (resolve, reject) {
      if (!file || !/^image\//.test(file.type)) return reject(new Error('no-imagen'));
      var url = URL.createObjectURL(file);
      var i = new Image();
      i.onload = function () {
        if (!i.naturalWidth) { URL.revokeObjectURL(url); return reject(new Error('sin-tamano')); }
        resolve(i);
      };
      i.onerror = function () { URL.revokeObjectURL(url); reject(new Error('carga')); };
      i.src = url;
    });
  }

  /* --- Guardar ------------------------------------------------------------- */

  function exportar(id) {
    var L = LZ();
    var w = EXPORT_MAX, h = Math.round(EXPORT_MAX * L[1] / L[0]);
    if (L[1] > L[0]) { h = EXPORT_MAX; w = Math.round(EXPORT_MAX * L[0] / L[1]); }
    var c = document.createElement('canvas');
    c.width = w; c.height = h;
    dibujar(c.getContext('2d'), w, h, id, false);
    return new Promise(function (resolve) { c.toBlob(resolve, 'image/png'); });
  }

  function escribirEncuadre() {
    var out = { producto: F.tipo || '' };
    var col = (F.fondo && F.fondo.relleno === 'opcion:Color') ? etiqueta('color', '') : '';
    if (col) out.color = col;
    CARAS.forEach(function (c) {
      var d = datos[c.id];
      if (!d.img) return;
      var pos = posDe(c.id);
      if (pos) out[(c.campo || c.nombre.toLowerCase()) + '_posicion'] = pos.nombre;
      out[c.campo || c.nombre.toLowerCase()] = {
        escala: Math.round(d.t.escala * 1000) / 1000,
        x: Math.round(d.t.x * 1000) / 1000,
        y: Math.round(d.t.y * 1000) / 1000,
        giro: d.t.giro,
        origen: d.nombre
      };
    });
    ponerTexto(PROP_ENCUADRE, JSON.stringify(out));
    /* Visible para el cliente y para el taller. */
    CARAS.forEach(function (c) {
      var pos = posDe(c.id);
      var campo = 'properties[Posición' + (UNA ? '' : ' ' + c.nombre.toLowerCase()) + ']';
      ponerTexto(campo, pos && datos[c.id].img ? pos.nombre : null);
    });
  }

  function guardarCara(id) {
    return exportar(id).then(function (blob) {
      if (!blob) return false;
      var c = cara(id);
      var nombre = 'vista-previa-' + (c.campo || c.id).toLowerCase() + '.png';
      var ok = ponerArchivo(campos(c).previa, new File([blob], nombre, { type: 'image/png' }));
      if (ok) {
        datos[id].guardado = true;
        datos[id].estado = 'listo';
        escribirEncuadre();
        pintarMiniatura(id, blob);
      }
      return ok;
    });
  }

  function guardar() {
    var id = activa;
    if (!datos[id].img) { cerrarModal(); return; }
    guardarCara(id).then(function (ok) {
      refrescarCandado();
      var sig = pendiente(id);
      if (ok && sig) { cambiarCara(sig); return; }
      cerrarModal();
    }).catch(function () { cerrarModal(); });
  }

  /* Si cambia el color o la forma, se rehacen las vistas previas guardadas. */
  function regenerar() {
    CARAS.forEach(function (c) {
      if (datos[c.id].img && datos[c.id].guardado) guardarCara(c.id).catch(function () {});
    });
  }

  function pintarMiniatura(id, blob) {
    var fila = document.querySelector('[data-hs-fila="' + id + '"]');
    if (!fila) return;
    var thumb = fila.querySelector('[data-hs-thumb]');
    if (thumb) {
      if (thumb.dataset.hsBlob) URL.revokeObjectURL(thumb.dataset.hsBlob);
      var u = URL.createObjectURL(blob);
      thumb.dataset.hsBlob = u;
      thumb.src = u;
      thumb.hidden = false;
    }
    fila.hidden = false;
  }

  function omitir(id, si) {
    var c = cara(id);
    if (si) {
      datos[id] = caraVacia();
      datos[id].estado = 'omitida';
      ponerArchivo(campos(c).previa, null);
      ponerTexto(campos(c).omitida, 'Sin diseño');
    } else {
      if (datos[id].estado === 'omitida') datos[id].estado = 'ninguno';
      ponerTexto(campos(c).omitida, null);
    }
    var nota = document.querySelector('[data-hs-sin="' + id + '"]');
    if (nota) nota.hidden = !si;
    escribirEncuadre();
    refrescarCandado();
    if (modal && !modal.hidden) { pintarModal(); repintar(); }
  }

  /* Diseno despues: el pedido sale con la nota y el diseno llega por email
     o WhatsApp. Si luego sube un archivo, manda el archivo y se quita la nota. */
  function disenoDespues(si) {
    despues = !!si;
    ponerTexto(PROP_DESPUES, despues ? TXT_DESPUES : null);
    var c = document.querySelector('[data-hs-despues]');
    if (c && c.checked !== despues) c.checked = despues;
    var nota = document.querySelector('[data-hs-despues-nota]');
    if (nota) nota.hidden = !despues;
    refrescarCandado();
  }

  function montarDespues() {
    var box = document.querySelector('[data-hs-uploader]');
    if (!box) return false;
    if (box.querySelector('[data-hs-despues]')) return true;
    var caja = el('div', 'hs-despues');
    var lab = el('label', 'hs-despues__label');
    var c = el('input', 'hs-despues__check');
    c.type = 'checkbox';
    c.setAttribute('data-hs-despues', '');
    c.addEventListener('change', function () { disenoDespues(c.checked); });
    lab.appendChild(c);
    lab.appendChild(el('span', '', 'No tengo el diseño a mano: lo envío después'));
    var nota = el('p', 'hs-despues__nota', 'Haz el pedido ahora y mándanos tu logo por email o WhatsApp. Antes de imprimir te enviamos una prueba digital gratis para que la apruebes.');
    nota.setAttribute('data-hs-despues-nota', '');
    nota.hidden = true;
    caja.appendChild(lab);
    caja.appendChild(nota);
    var err = box.querySelector('[data-hs-error]');
    box.insertBefore(caja, err || null);
    return true;
  }

  function limpiar(id) {
    datos[id] = caraVacia();
    ponerArchivo(campos(cara(id)).previa, null);
    escribirEncuadre();
    refrescarCandado();
    if (modal && !modal.hidden) { pintarModal(); repintar(); }
  }

  /* --- Candado de compra --------------------------------------------------- */

  function listaOk(id) {
    if (despues) return true;
    var e = datos[id].estado;
    return e === 'listo' || e === 'sin-previa' || e === 'omitida';
  }

  function extras() {
    /* Módulos que también pueden bloquear la compra, como el reparto de
       tallas. Se registran solos en HSExtras. */
    var ms = window.HSExtras || [];
    for (var i = 0; i < ms.length; i++) {
      try {
        var r = ms[i]();
        if (r && r.ok === false) return r;
      } catch (e) {}
    }
    return null;
  }

  function puedeComprar() {
    if (!combinacionOk) return false;
    for (var i = 0; i < CARAS.length; i++) {
      if (CARAS[i].obligatoria !== false && !listaOk(CARAS[i].id)) return false;
    }
    return !extras();
  }

  function cajaBotones() { return document.querySelector('.product-form-buttons'); }

  function avisoCandado() {
    var caja = cajaBotones();
    if (!caja) return null;
    var n = caja.querySelector('[data-hs-candado]');
    if (!n) {
      n = el('div', 'hs-candado');
      n.setAttribute('data-hs-candado', '');
      var txt = el('span', 'hs-candado__txt', '');
      txt.setAttribute('data-hs-candado-txt', '');
      var b = el('button', 'hs-candado__b', '');
      b.type = 'button';
      b.setAttribute('data-hs-candado-b', '');
      b.addEventListener('click', function () {
        var falta = primeraFalta();
        if (falta) { API.abrir(falta); return; }
        var ex = extras();
        if (ex && ex.foco) {
          var n2 = document.querySelector(ex.foco);
          if (n2 && n2.scrollIntoView) n2.scrollIntoView({ block: 'center', behavior: 'smooth' });
          var i2 = n2 && n2.querySelector('input');
          if (i2) i2.focus({ preventScroll: true });
        }
      });
      n.appendChild(txt);
      n.appendChild(b);
      caja.insertBefore(n, caja.firstChild);
    }
    return n;
  }

  function primeraFalta() {
    for (var i = 0; i < CARAS.length; i++) {
      if (CARAS[i].obligatoria !== false && !listaOk(CARAS[i].id)) return CARAS[i].id;
    }
    return null;
  }

  function aplicarCandado() {
    var bloqueado = !puedeComprar();

    var add = document.querySelector('button[name="add"]');
    if (add) {
      if (bloqueado) {
        if (!add.dataset.hsLock) add.dataset.hsLock = add.disabled ? 'suyo' : 'nuestro';
        if (!add.disabled) add.disabled = true;
        add.setAttribute('aria-disabled', 'true');
      } else if (add.dataset.hsLock) {
        if (add.dataset.hsLock === 'nuestro') {
          add.disabled = false;
          add.removeAttribute('aria-disabled');
        }
        delete add.dataset.hsLock;
      }
    }

    var express = document.querySelector('.accelerated-checkout-block');
    if (express && express.classList.contains('hs-bloqueado') !== bloqueado) {
      express.classList.toggle('hs-bloqueado', bloqueado);
    }

    var n = avisoCandado();
    if (!n) return;
    if (n.hidden === bloqueado) n.hidden = !bloqueado;
    if (!bloqueado) return;

    var txt = n.querySelector('[data-hs-candado-txt]');
    var b = n.querySelector('[data-hs-candado-b]');
    var mensaje = '', texto = '';

    if (!combinacionOk) {
      mensaje = 'Esa combinación no está disponible ahora mismo. Prueba con otras opciones.';
    } else {
      var falta = primeraFalta();
      if (falta) {
        var c = cara(falta);
        var nuevo = datos[falta].estado === 'ninguno';
        mensaje = nuevo
          ? (c.texto_candado
              ? c.texto_candado + ' ¿No lo tienes a mano? Marca «Lo envío después».'
              : ('Sube tu diseño' + (UNA ? '' : ' de ' + c.nombre.toLowerCase()) + ' o marca «Lo envío después» para añadirlo al carrito.'))
          : ('Te falta ajustar tu diseño' + (UNA ? '' : ' de ' + c.nombre.toLowerCase()) + '.');
        texto = nuevo ? 'Subir diseño' : 'Ajustar ahora';
      } else {
        var ex = extras();
        mensaje = (ex && ex.mensaje) || 'Revisa las opciones del pedido.';
        texto = (ex && ex.boton) || '';
      }
    }
    if (txt && txt.textContent !== mensaje) txt.textContent = mensaje;
    if (b) {
      if (b.textContent !== texto) b.textContent = texto;
      if (b.hidden === !!texto) b.hidden = !texto;
    }
  }

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.action || f.action.indexOf('/cart/add') === -1) return;
    if (puedeComprar()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    aplicarCandado();
    var n = document.querySelector('[data-hs-candado]');
    if (n && n.scrollIntoView) n.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }, true);

  document.addEventListener('click', function (e) {
    if (puedeComprar()) return;
    var t = e.target.closest && e.target.closest('.accelerated-checkout-block, button[name="add"]');
    if (!t) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    aplicarCandado();
  }, true);

  var candadoPend = null, moCandado = null;

  function vigilarCandado() {
    var caja = cajaBotones();
    if (!caja) return;
    if (!moCandado) {
      moCandado = new MutationObserver(function () {
        clearTimeout(candadoPend);
        candadoPend = setTimeout(refrescarCandado, 80);
      });
    }
    moCandado.observe(caja, { childList: true, subtree: true });
  }

  function refrescarCandado() {
    if (moCandado) moCandado.disconnect();
    try { aplicarCandado(); } finally { vigilarCandado(); }
  }

  function arrancarCandado() {
    if (!cajaBotones()) return false;
    try { montarDespues(); } catch (e) {}
    refrescarCandado();
    return true;
  }

  if (!arrancarCandado()) {
    var intentos = 0;
    var tmr = setInterval(function () {
      if (arrancarCandado() || ++intentos > 40) clearInterval(tmr);
    }, 250);
  }

  document.addEventListener('hs:cambio', refrescarCandado);

  /* --- Añadir al carrito ---------------------------------------------------
     Lo enviamos nosotros y esperamos la respuesta de Shopify: si entra, al
     carrito; si no, se ve el motivo y el diseño sigue puesto. */

  var enviando = false;

  function avisoDeError(texto) {
    var f = formularioCompra();
    if (!f) return;
    var n = f.querySelector('[data-hs-error-carrito]');
    if (!n) {
      n = el('p', 'hs-errorcarrito');
      n.setAttribute('data-hs-error-carrito', '');
      var caja = cajaBotones();
      if (caja) caja.insertBefore(n, caja.firstChild);
      else f.appendChild(n);
    }
    n.textContent = texto;
    n.hidden = !texto;
    if (texto && n.scrollIntoView) n.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }

  function avisoDeEspera(texto) {
    var caja = cajaBotones();
    if (!caja) return;
    var n = caja.querySelector('[data-hs-espera]');
    if (!n) {
      n = el('p', 'hs-espera');
      n.setAttribute('data-hs-espera', '');
      n.setAttribute('role', 'status');
      caja.insertBefore(n, caja.firstChild);
    }
    n.textContent = texto;
    n.hidden = !texto;
  }

  function anadirAlCarrito() {
    var f = formularioCompra();
    if (!f || enviando) return;
    enviando = true;
    avisoDeError('');

    var botones = [].slice.call(document.querySelectorAll('button[name="add"]'));
    botones.forEach(function (b) { b.disabled = true; b.setAttribute('aria-busy', 'true'); });
    avisoDeEspera(UNA ? 'Subiendo tu diseño…' : 'Subiendo tus diseños…');

    var cuerpo = new FormData(f);
    cuerpo.delete('sections');
    var vacios = [];
    cuerpo.forEach(function (v, k) { if (v instanceof File && !v.name && !v.size) vacios.push(k); });
    vacios.forEach(function (k) { cuerpo.delete(k); });

    fetch('/cart/add.js', {
      method: 'POST',
      body: cuerpo,
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) {
        return r.json().then(function (d) { return { ok: r.ok, status: r.status, d: d }; });
      })
      .then(function (res) {
        if (res.ok && !res.d.status) { window.location.href = '/cart'; return; }
        var crudo = (res.d && (res.d.description || res.d.message)) || ('HTTP ' + res.status);
        if (window.console) console.warn('[holasticker] carrito rechazado:', crudo, res.d);
        var msg = 'No hemos podido añadir tu pedido al carrito. '
                + 'Comprueba las opciones y vuelve a intentarlo. Tu diseño sigue guardado.';
        if (/too large|demasiado grande|size/i.test(crudo)) {
          msg = 'El archivo pesa demasiado para enviarlo. Prueba con una imagen más ligera.';
        }
        throw new Error(msg);
      })
      .catch(function (e) {
        enviando = false;
        botones.forEach(function (b) { b.disabled = false; b.removeAttribute('aria-busy'); });
        avisoDeEspera('');
        refrescarCandado();
        avisoDeError(String(e.message || e));
      });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('button[name="add"]');
    if (!b) return;
    if (!puedeComprar()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    anadirAlCarrito();
  }, true);

  /* --- API ------------------------------------------------------------------ */

  var API = {
    abrir: function (id) {
      try {
        id = datos[id] ? id : CARAS[0].id;
        activa = id;
        if (datos[id].img) { abrirModal(); return; }
        /* Caras posteriores: se abre el modal con su pantalla de subida. */
        if (id !== CARAS[0].id) { abrirModal(); return; }
        var i = inputDe(id);
        var f = i && i.files && i.files[0];
        if (!f) { if (i) i.click(); return; }
        API.usar(id, f);
      } catch (e) { if (window.console) console.warn('[holasticker] editor:', e); }
    },

    usar: function (id, file) {
      try {
        omitir(id, false);
        if (despues) disenoDespues(false);
        var d = datos[id];
        d.nombre = file ? file.name : '';
        cargar(file).then(function (i) {
          d.img = i;
          d.guardado = false;
          d.estado = 'pendiente';
          d.t = { escala: 1, x: 0, y: 0, giro: 0 };
          ponerArchivo(campos(cara(id)).previa, null);
          refrescarCandado();
          activa = id;
          abrirModal();
        }).catch(function () {
          datos[id] = caraVacia();
          datos[id].nombre = d.nombre;
          datos[id].estado = 'sin-previa';
          ponerArchivo(campos(cara(id)).previa, null);
          refrescarCandado();
          var err = document.querySelector('[data-hs-uploader] [data-hs-error]');
          if (err) {
            err.textContent = 'Ese archivo se envía igual, pero no podemos mostrarte la vista previa. Si quieres verla, sube un PNG o un JPG.';
            err.hidden = false;
          }
          if (modal && !modal.hidden) pintarModal();
        });
      } catch (e) { if (window.console) console.warn('[holasticker] editor:', e); }
    },

    combinacion: function (hay) {
      if (combinacionOk === !!hay) return;
      combinacionOk = !!hay;
      refrescarCandado();
    },
    limpiar: limpiar,
    omitir: omitir,
    disenoDespues: disenoDespues,
    refrescar: refrescarCandado,
    ficha: F
  };

  /* Cambios en los selectores: el producto se repinta y, si hace falta, se
     rehacen las vistas previas (por ejemplo al cambiar de color). */
  document.addEventListener('change', function (e) {
    var r = e.target.closest && e.target.closest('[data-hs-group]');
    if (!r) return;
    if (modal && !modal.hidden) { pintarModal(); medirLienzo(); }
    if (r.dataset.hsGroup === 'color' || r.dataset.hsGroup === 'shape'
        || (F.formas && r.dataset.hsGroup === (F.formas.grupo || 'forma'))
        || (F.lienzo_opcion && r.dataset.hsGroup === (F.lienzo_opcion.grupo || 'tamano'))) regenerar();
    refrescarCandado();
  });

  window.HSPersonalizador = API;
})();
